<template>
  <div>
    <h3 class="mb-5">Product Description</h3>
    <div class="h4 mb-5">
      顯示於產品頁Description區塊, 僅適用[Section Type為上下區塊 or 三欄式)
    </div>
    <label class="form-item d-flex py-3">
      <div class="w-200px">
        <h4>Product Description</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-combobox
          v-model="description"
          :items="product.descriptions"
          item-text="title"
          outlined
          dense
        >
        </v-combobox>
      </div>
    </label>
    <div v-if="description != null">
      <!-- items -->
      <PageCollapse v-for="(item, i) in description.ksps" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">{{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(i)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <!-- title -->
          <div class="d-flex px-5 pt-5 mb-8">
            <div class="w-180px mt-5">
              <h4 class="mb-10px">標題</h4>
            </div>
            <div class="flex-grow-1 mt-3">
              <div class="form-input-group">
                <input
                  type="text"
                  placeholder="請輸入標題"
                  v-model="item.title"
                />
            </div>
          </div>
          </div>
          <!-- Description -->
          <div class="d-flex px-5 pt-5 mb-8">
            <div class="w-180px mt-5">
              <h4 class="mb-10px">Description</h4>
            </div>
            <div class="flex-grow-1 mt-3">
              <div class="form-input-group">
                <input
                  type="text"
                  placeholder="請輸入Description"
                  v-model="item.description"
                />
              </div>
            </div>
          </div>
          <!-- 顯示/隱藏 -->
          <div class="d-flex px-5 pt-5 mb-8">
            <div class="w-180px mt-5">
              <h4>顯示/隱藏</h4>
            </div>
            <div class="flex-grow-1 flex-basis-0">
              <FormSwitch v-model="item.status"></FormSwitch>
            </div>
          </div>
          <!-- 按鈕連結 -->
          <div class="d-flex px-5 pt-5 mb-8">
            <h4 class="w-180px my-5 mr-6">按鈕連結</h4>
            <div class="flex-grow-1 my-3">
              <div class="form-input-group">
                <input
                  type="text"
                  v-model="item.url"
                />
              </div>
            </div>
          </div>
          <!-- img uploader -->
          <div class="d-flex px-5 pt-5 mb-8">
            <div class="w-180px">
              <h4 class="mb-10px">圖片</h4>
              <div class="h5 ink-02-medium--text">
                建議尺寸：999px * 999px <br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.image"
                :dir="productDescription"></ImgUploader>
            </div>
          </div>
        </template>
      </PageCollapse>

      <!-- 添加 item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加項目</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
    FormSwitch,
  },
  data: () => ({
    dir: 'product',
    description: null,
  }),
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        description: '',
        status: false,
        image: '',
      };
      this.description.ksps.push(template);
    },
    deleteItem(index) {
      this.description.ksps.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.description.ksps.length - 1) {
        this.description.ksps.splice(i, 1);
        this.description.ksps.unshift(item);
        return;
      }
      // item become next index
      this.description.ksps.splice(i, 1);
      this.description.ksps.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.description.ksps.splice(i, 1);
        this.description.ksps.push(item);
        return;
      }
      // item become previous index
      this.description.ksps.splice(i, 1);
      this.description.ksps.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
